import React from 'react';
import { useOptimizelyFeature } from 'hooks/useOptimizelyFeature';
import { detectLocale } from 'i18n/detectLocale';

export const LocaleContext = React.createContext('en');

export function LocaleProvider({
  locale = 'en',
  children,
}: {
  locale?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const [isI18nEnabled] = useOptimizelyFeature('i18n');
  const isPseudoMode = BUILD_ENVIRONMENT === 'development-pseudo';
  const resolvedLocale = isPseudoMode
    ? 'pseudo'
    : isI18nEnabled
    ? detectLocale()
    : locale;

  return (
    <LocaleContext.Provider value={resolvedLocale}>
      {children}
    </LocaleContext.Provider>
  );
}
